module.exports = __webpack_public_path__ + "static/logo-placeholder-1dd65a42a62ff960f86ed08a42c05dec.png";